import React from 'react'

function Brand({ src, alt, heading, description, href }) {
  return (
      <div className='p-3 flex flex-col md:flex-row items-center gap-3'>
          <div className='w-full lg:h-[450px] md:w-1/2'>
              <img className='w-full h-full' src={src} alt={alt} />
          </div>
          <div className='w-full md:w-1/2 flex flex-col items-center gap-3'>
              <h1 className='text-center text-3xl font-open-sans font-medium'>{heading}</h1>
              <p className='text-center text-md font-roboto font-light'>{description}</p>
              <a className='w-full bg-orange p-5 text-center text-white text-xl font-roboto font-medium' 
                href={href} target='_blank' rel="noreferrer">Know More</a>
          </div>
      </div>
  )
}

export default Brand